/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PureComponent } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { List } from 'foundations-components/transitional/components/List';
import { Link } from 'foundations-components/transitional/components/Link';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { isConversationsAdmin } from 'ui-addon-sales-email/user/Permissions';
import StepInterface from './StepInterface';
import { FAILURE_STEP, CHOOSE_PROVIDER_STEP } from '../../constants/InboxConnectStepKeys';
import { getInboxErrorMessage, getHandledInboxErrorMessage } from '../../utils/Validation';
import { generateAdminEmailLink } from '../../utils/AdminEmail';
import { parseSharedInboxAlreadyConnectedPersonally } from '../../constants/InboxErrors';
import RemoveAllConnectionsPrompt from '../prompts/RemoveAllConnectionsPrompt';
import { addError, addSuccess } from '../../utils/Alerts';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.wizard.failure';
const ErrorCodeReport = ({
  connectError
}) => {
  if (!connectError) {
    return null;
  }
  const errorToRender = typeof connectError === 'string' ? connectError : JSON.stringify(connectError);
  return /*#__PURE__*/_jsx("p", {
    children: errorToRender
  });
};
export default class FailureStep extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fixFunction: null,
      showErrorLog: false
    };
  }
  componentDidMount() {
    const {
      trackingClient,
      connectError
    } = this.props;
    trackingClient.trackStepView(FAILURE_STEP, `${connectError}`, getHandledInboxErrorMessage(connectError) ? '' : 'UNHANDLED');
    this.checkAutoRepairability();
  }
  checkAutoRepairability() {
    const {
      service,
      connectError,
      trackingClient
    } = this.props;
    const sharedInboxPersonalConnected = parseSharedInboxAlreadyConnectedPersonally(connectError);
    if (sharedInboxPersonalConnected && service.removeAllConnectionsForEmail && service.getUserInfo) {
      service.getUserInfo().then(userInfo => {
        if (isConversationsAdmin(userInfo)) {
          const {
            emailAddress,
            usersEmails
          } = sharedInboxPersonalConnected;
          const fixFunction = () => {
            RemoveAllConnectionsPrompt({
              emailAddress,
              usersEmails
            }).then(() => service.removeAllConnectionsForEmail(emailAddress)).then(() => addSuccess(`${LANG_ROUTE}.repairSucceeded`)).then(() => this.props.setShownStep(CHOOSE_PROVIDER_STEP)).catch(error => {
              const errorMessage = error && (error.errorMessage || error.statusText);
              if (errorMessage) {
                addError(`${LANG_ROUTE}.repairFailed`, {
                  errorMessage
                });
              }
            });
            trackingClient.trackStepAction(FAILURE_STEP, 'repair-shared-personal-disconnect');
          };
          this.setState({
            fixFunction
          });
        }
      });
    }
  }
  renderDefaultRepairSteps() {
    const {
      setShownStep,
      trackingClient,
      connectError,
      emailAddress
    } = this.props;
    const {
      showErrorLog
    } = this.state;
    const trackAdminShareClick = () => trackingClient.trackStepAction(FAILURE_STEP, 'share');
    return /*#__PURE__*/_jsxs(View, {
      marginBlock: "200",
      "data-selenium": "failure-step",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h5",
          textAlign: "left",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${LANG_ROUTE}.whatYouCanDo.title`
          })
        }), /*#__PURE__*/_jsxs(List, {
          ordered: true,
          styled: true,
          wrapChildren: true,
          children: [/*#__PURE__*/_jsx(Text, {
            textAlign: "left",
            children: /*#__PURE__*/_jsx(Link, {
              href: generateAdminEmailLink(connectError, {
                emailAddress
              }),
              onClick: trackAdminShareClick,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `${LANG_ROUTE}.whatYouCanDo.steps.shareMessage`
              })
            })
          }), /*#__PURE__*/_jsx(Text, {
            textAlign: "left",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `${LANG_ROUTE}.whatYouCanDo.steps.reconnect`
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(ButtonWrapper, {
        marginBlockStart: "400",
        justify: "center",
        children: [/*#__PURE__*/_jsx(Button, {
          name: "reconnect",
          use: "primary",
          onClick: () => setShownStep(CHOOSE_PROVIDER_STEP),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${LANG_ROUTE}.reconnectButton`
          })
        }), showErrorLog ? null : /*#__PURE__*/_jsx(Button, {
          name: "showLog",
          onClick: () => this.setState({
            showErrorLog: true
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${LANG_ROUTE}.showLog`
          })
        })]
      })]
    });
  }
  renderRepairButton(repairFunc) {
    return /*#__PURE__*/_jsx(ButtonWrapper, {
      justify: "center",
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: repairFunc,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_ROUTE}.repairButton`
        })
      })
    });
  }
  renderRepairSection() {
    const {
      fixFunction
    } = this.state;
    return fixFunction ? this.renderRepairButton(fixFunction) : this.renderDefaultRepairSteps();
  }
  renderNextButton(onErrorScreenClickNext) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "800",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `${LANG_ROUTE}.connectLater`
        })
      }), /*#__PURE__*/_jsx(ButtonWrapper, {
        justify: "center",
        children: /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: onErrorScreenClickNext,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${LANG_ROUTE}.nextButton`
          })
        })
      })]
    });
  }
  render() {
    const {
      showErrorLog
    } = this.state;
    const {
      connectError,
      emailAddress,
      oauthOptions
    } = this.props;
    const {
      key,
      options
    } = getInboxErrorMessage(connectError);

    // compose with other state that should be in every error message
    const composedOptions = Object.assign({}, options, {
      emailAddress
    });
    const onErrorScreenClickNext = oauthOptions && oauthOptions.onErrorScreenClickNext;
    const nextStepsSection = onErrorScreenClickNext ? this.renderNextButton(onErrorScreenClickNext) : this.renderDefaultRepairSteps();
    const alertTitle = /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${LANG_ROUTE}.title`
    });
    return /*#__PURE__*/_jsxs(View, {
      marginBlock: "300",
      "data-selenium": "failure-step",
      children: [/*#__PURE__*/_jsxs(Alert, {
        type: "danger",
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: key,
            options: composedOptions
          })
        }), showErrorLog && /*#__PURE__*/_jsx(ErrorCodeReport, {
          connectError: connectError
        })]
      }), /*#__PURE__*/_jsx(Text, {
        as: "h5",
        marginBlock: "400",
        textAlign: "left",
        children: alertTitle
      }), nextStepsSection]
    });
  }
}
FailureStep.propTypes = StepInterface;